export const USER_DOWNLOAD_TASK_NAME = 'user-download';
export const USER_DOWNLOAD_FILE_NAME = 'User-info-report';
